import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDataLink = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 17 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M1.669 8.714V6.828c0-.84.683-1.523 1.523-1.523h3.48a.653.653 0 000-1.305h-3.48A2.831 2.831 0 00.364 6.828v1.886a2.831 2.831 0 002.828 2.828h3.48a.653.653 0 000-1.306h-3.48c-.84 0-1.523-.683-1.523-1.522zM13.536 4h-3.48a.653.653 0 000 1.305h3.48c.84 0 1.522.683 1.522 1.523v1.886c0 .839-.683 1.522-1.522 1.522h-3.48a.653.653 0 000 1.306h3.48a2.831 2.831 0 002.828-2.828V6.828A2.831 2.831 0 0013.536 4zM4.914 8.423h6.9a.653.653 0 000-1.305h-6.9a.653.653 0 000 1.305z" })
});
export default SvgDataLink;
